import { Injectable } from '@angular/core';
import { BasketWebservice } from '@core/services/basket.webservice';
import { Action, NgxsOnInit, Selector, State, StateContext, StateToken, Store } from '@ngxs/store';
import { DossierGet } from '@stores/dossier/dossier.action';
import { JwtState } from '@stores/jwt/jwt.state';
import { SuggestionGetByMissingIds } from '@stores/suggestion/suggestion.action';
import { Dossier } from '@wizbii/models';
import { filter, map, switchMap, tap } from 'rxjs/operators';

export type DossierStateModel = Dossier[];
export const DossierStateToken = new StateToken<DossierStateModel>('dossier');

@State({
  name: DossierStateToken,
  defaults: null,
})
@Injectable()
export class DossierState implements NgxsOnInit {
  @Selector([DossierState])
  static dossiers(dossierState: DossierStateModel): Dossier[] {
    return dossierState;
  }
  constructor(private readonly store: Store, private readonly fibiiWebservice: BasketWebservice) {}

  ngxsOnInit(ctx?: StateContext<any>): any {
    this.store
      .select(JwtState)
      .pipe(
        filter((tokens) => !!tokens),
        switchMap(() => this.store.dispatch(new DossierGet()))
      )
      .subscribe();
  }

  @Action(DossierGet)
  folderGet(ctx: StateContext<DossierStateModel>) {
    return this.fibiiWebservice.getDossiers().pipe(
      tap((dossiers) => ctx.setState(dossiers)),
      map((dossiers) => dossiers.map((dossier) => dossier.suggestionId)),
      tap((suggestionIds) => ctx.dispatch(new SuggestionGetByMissingIds(suggestionIds)))
    );
  }
}
